// extracted by mini-css-extract-plugin
export default {"pageLayout":"ub-z","mainContent":"vb-z","columnLayout":"wb-z","columnLayoutFill":"xb-z","columnLayoutLast":"yb-z"};